/**
 * Role SSO ouvrant l'acces aux e-factures.
 *
 * Porte par le SSO (`SsoApiAyService.getSsoClientRoles`) et non par les fonctionnalites site :
 * c'est le SSO qui arbitre l'acces au backend efacture, et son 401 est ce qui ejecte
 * l'utilisateur de l'application. Les roles arrivent dans `FullClient.roles`, agreges par
 * `ClientFacade.generateFullClient*`.
 *
 * Deux consommateurs, meme source :
 * - `optionSouscrite` de `provideFactureElectronique` (app-ay.module.ts) : sans le role, la lib
 *   rend l'ecran de souscription et n'appelle PAS le back efacture. L'entree de menu reste
 *   donc visible, avec son ecran de vente.
 * - le garde de la route `e-factures/factures` : la liste des factures n'a aucun sens sans le
 *   role, et un acces direct rejouerait le 401.
 */
export const ROLE_EFACTURES = "EFACTURES";
